import { render, staticRenderFns } from "./ChangelogCategorySelector.vue?vue&type=template&id=0e5d0b8c&scoped=true&"
import script from "./ChangelogCategorySelector.vue?vue&type=script&lang=ts&"
export * from "./ChangelogCategorySelector.vue?vue&type=script&lang=ts&"
import style0 from "./ChangelogCategorySelector.vue?vue&type=style&index=0&id=0e5d0b8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5d0b8c",
  null
  
)

export default component.exports